import React from 'react';
import { approveToolExecution, rejectToolExecution } from '@api/toolApprovals';
import ToolChip from '@components/Chat/ToolChip';
import type { ToolApprovalRequest } from '@utils/toolApprovalRequest';
import { ApprovalList } from './AppRunApprovals.styled';

interface AppRunApprovalsProps {
  readonly conversationId: string;
  readonly approvals: readonly ToolApprovalRequest[];
  readonly onSettled: (toolUseId: string) => void;
}

/** The actions on the person's computer waiting for their OK, with the same card the chat shows. */
const AppRunApprovals: React.FC<AppRunApprovalsProps> = ({ conversationId, approvals, onSettled }) => (
  <ApprovalList data-testid="app-run__approvals">
    {approvals.map((approval) => (
      <ToolChip
        key={approval.toolUseId ?? approval.tool}
        tool={{ ...approval, status: 'pending_approval' }}
        onApprove={async (toolUseId) => {
          await approveToolExecution(conversationId, toolUseId);
          onSettled(toolUseId);
        }}
        onReject={async (toolUseId, comment) => {
          await rejectToolExecution(conversationId, toolUseId, comment);
          onSettled(toolUseId);
        }}
      />
    ))}
  </ApprovalList>
);

export default AppRunApprovals;
